/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The base generic error response
 */
export type CheckoutCartBadRequestError = {
    /**
     * The error code
     */
    code: CheckoutCartBadRequestError.code;
    /**
     * The error message
     */
    error: string;
};
export namespace CheckoutCartBadRequestError {
    /**
     * The error code
     */
    export enum code {
        CART_NOT_FOUND = 'cart_not_found',
        EMPTY_CART = 'empty_cart',
        MISSING_CREDENTIALS = 'missing_credentials',
        VAT_NUMBER_REQUIRED = 'vat_number_required',
        INVALID_TAX_ID = 'invalid_tax_id',
        INVALID_VAT_NUMBER = 'invalid_vat_number',
        NAME_REQUIRED = 'name_required',
        SURNAME_REQUIRED = 'surname_required',
        TAX_ID_REQUIRED = 'tax_id_required',
        INVALID_PROVINCE = 'invalid_province',
        PRODUCT_NOT_FOUND = 'product_not_found',
        PRICE_NOT_FOUND = 'price_not_found',
        NO_AMOUNT_DUE = 'no_amount_due',
        PAYMENT_INTENT_NOT_FOUND = 'payment_intent_not_found',
        INVALID_PROMO_CODE = 'invalid_promo_code',
        ALREADY_DISCOUNTED = 'already_discounted',
        INTERNAL_SERVER_ERROR = 'internal_server_error',
        MISSING_ID = 'missing_id',
        CHECKOUT_SESSION_NOT_FOUND = 'checkout_session_not_found',
        FORBIDDEN = 'forbidden',
    }
}

